<template>
  <div class="agx-grid-work-machines">
    <div class="top_machine_border"></div>
    <div v-for="(employee, index) in registeredEmployees" :key="employee.uuid">
      <div
          class="grid_custom_row grid_custom_row_machine"
          :class="[
          { selected_row: employee.selected },
          {bottom_radius: last_work && employee.expanded == false && registeredEmployees.length == (index + 1)}
        ]"
      >
        <div class="left_side">
          <b-form-checkbox
              class="select_row_checkbox"
              size="sm"
              v-if="start_mode == true"
              v-model="employee.selected"
              @change="machine_selected_event($event, index, employee)"
          >
          </b-form-checkbox>
          <div
              class="machine_name"
              :id="'ms_' + employee.uuid"
              @click="machineNameClick"
          >
            {{
              templateData.is_dataller_work ? 'Zilieri' : (employee.name ?? 'Necunoscut')
            }}
          </div>
          <div class="machine_name_spacer"></div>
        </div>

        <div class="right_side">
          <div class="total_surface">{{ employee.total_surface_worked }} ha</div>
          <div class="parcel_count">
            <img src="@/assets/images/icons/parcel2.svg"/>
            <span>{{ employee.parcels_count }}</span>
          </div>
          <div>
            <img
                class="expand_button"
                v-if="employee.expanded"
                src="@/assets/images/icons/machine_expanded.svg"
                @click="expandGrid(index, employee)"
            />
            <img
                class="expand_button_down"
                v-else
                src="@/assets/images/icons/arrow_down.svg"
                @click="expandGrid(index, employee)"
            />
          </div>
        </div>
      </div>
      <div v-show="employee.expanded">
        <works-on-parcels
            :ref="'parcels_' + employee.uuid"
            :template-data="{ data: employee }"
            :work_uuid="templateData.work_uuid"
            :date_from="templateData.date"
            :date_to="templateData.date"
            :department_uuid="department_uuid"
            :start_mode="start_mode"
            :parent_expanded="employee.expanded"
            :parent_selected="employee.selected"
            @selectParcel="selectParcel"
            :last_machine="last_work && registeredEmployees.length == (index + 1)"
            :workListFilters="workListFilters"
            @showMapForParcel="showMapForParcel"
            :usage_mode="usage_mode"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import WorksOnParcels from "./worksOnParcels";

export default {
  name: "workWithEmployee",
  props: {
    templateData: {
      type: Object,
      default: () => {
      },
    },
    workListFilters: {
      type: Object,
      default: () => {
      },
    },
    department_uuid: "",
    usage_mode: "",
    fill_grid: false,
    start_mode: false,
    parent_expanded: false,
    parent_selected: false,
    last_work: false,

  },
  data() {
    return {
      registeredEmployees: [],
      tooltip: {
        visible: false,
        target: "",
        text: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      departments: "company/departments",
    }),
  },
  watch: {
    registeredEmployees: {
      handler: function (newVal) {
        this.items = newVal;
      },
      deep: true,
    },
    parent_expanded(newVal, oldValue) {
      if (newVal == true && this.registeredEmployees.length <= 0) {
        this.getEmployees();
      }
    },
  },
  components: {
    WorksOnParcels,
  },
  methods: {
    ...mapActions({
      getEmployeeGroups: "works-persons/getEmployeeGroups",
    }),
    showMapForParcel(parcel_uuid, season_uuid) {
      this.$emit("showMapForParcel", parcel_uuid, season_uuid);
    },
    machineNameClick(target) {
      // this.tooltip.text = "some test";
      // this.tooltip.target = "#mns_" + target;
      //this.tooltip.visible = false;
      //this.$refs.machine_tooltip.show();
    },
    selectParcel(select, parcel, allParcelAreUnchecked) {
      this.$emit("selectParcel", select, parcel);
      this.selectMachineByParcel(select, parcel, allParcelAreUnchecked);
    },
    selectMachineByParcel(select, parcel, allParcelAreUnchecked) {
      if (select) {
        this.registeredEmployees.forEach((m, index) => {
          if (m.uuid == parcel.machine_uuid) {
            m.selected = true;
            this.$set(this.registeredEmployees, index, m);
          }
        });
      } else {
        if (allParcelAreUnchecked) {
          this.registeredEmployees.forEach((m, index) => {
            if (m.uuid == parcel.machine_uuid) {
              m.selected = false;
              this.$set(this.registeredEmployees, index, m);
            }
          });
        }
      }
      this.$emit("selectWorkByMachine", select, this.templateData);
    },
    machine_selected_event(selected, index, machine) {
      let checkObj = this.registeredEmployees.find(
          (x) => x.uuid == machine.uuid
      );
      checkObj.selected = selected;
      this.$set(this.registeredEmployees, index, checkObj);
      this.$emit(
          "selectMachine",
          selected,
          machine.uuid,
          this.department_uuid,
          this.templateData
      );

      if (this.$refs["parcels_" + machine.uuid]) {
        if (selected) {
          this.$refs["parcels_" + machine.uuid][0].selectAllParcels();
        } else {
          this.$refs["parcels_" + machine.uuid][0].deselectAllParcels();
        }
      }
    },
    selectAllMachines() {
      this.registeredEmployees.forEach((m, index) => {
        m.selected = true;
        this.$set(this.registeredEmployees, index, m);
        if (this.$refs["parcels_" + m.uuid]) {
          this.$refs["parcels_" + m.uuid][0].selectAllParcels();
        }
      });
    },
    deselectAllMachines() {
      this.registeredEmployees.forEach((m, index) => {
        m.selected = false;
        this.$set(this.registeredEmployees, index, m);
        if (this.$refs["parcels_" + m.uuid]) {
          this.$refs["parcels_" + m.uuid][0].deselectAllParcels();
        }
      });
    },
    expandGrid(index, employee) {
      let checkObj = this.registeredEmployees.find(
          (x) => x.uuid == employee.uuid
      );
      checkObj.expanded = !checkObj.expanded;
      this.$set(this.registeredEmployees, index, checkObj);
    },
    getEmployees() {
      let localDepartmentFilter = []
      if (this.workListFilters && this.workListFilters.departments) {
        this.workListFilters.departments.forEach(d => {
          if (this.departments.find(dep => dep.uuid == d)) {
            localDepartmentFilter.push(d);
          }
        });
      }

      this.getEmployeeGroups({
        department_uuid: localDepartmentFilter.join(),
        date_from: this.templateData.date,
        date_to: this.templateData.date,
        work_uuid: this.templateData.work_uuid,
        parcel_uuid: this.workListFilters && this.workListFilters.parcels ? this.workListFilters.parcels.join() : null,
        product_uuid: this.workListFilters && this.workListFilters.products ? this.workListFilters.products.join() : null,
        season_uuid: this.workListFilters && this.workListFilters.seasons ? this.workListFilters.seasons.join() : null,
      }).then((payload) => {
        payload.forEach((employee) => {
          employee.selected = this.parent_selected;
          employee.expanded = false;
          this.registeredEmployees.push(employee);
        });
      });
    },
  },

  mounted() {
    if (this.parent_expanded && this.registeredEmployees.length == 0) {
      this.getEmployees();
    }
  },
};
</script>
